var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 143.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#689f63;}.cls-3{fill:#333;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#linear-gradient);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{clip-path:url(#clip-path-3);}.cls-9{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.66,38.89l-19,11a2.3,2.3,0,0,0-1.15,2v22a2.3,2.3,0,0,0,1.15,2l19,11a2.31,2.31,0,0,0,2.3,0l19-11a2.3,2.3,0,0,0,1.15-2v-22a2.3,2.3,0,0,0-1.15-2l-19-11a2.32,2.32,0,0,0-2.31,0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -316.45,
    y1: 373.35,
    x2: -315.91,
    y2: 373.35,
    gradientTransform: "matrix(-50.75, 103.54, 103.54, 50.75, -54628.92, 13850.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5aad45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.94,75.28a2.3,2.3,0,0,0,.68.59L70,85.31l2.72,1.56a2.31,2.31,0,0,0,1.33.3,2.35,2.35,0,0,0,.45-.08L94.55,50.31a2.28,2.28,0,0,0-.54-.42l-12.47-7.2-6.59-3.79a2.4,2.4,0,0,0-.6-.24Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -316.77,
    y1: 370.32,
    x2: -316.42,
    y2: 370.32,
    gradientTransform: "matrix(142.41, -105.22, -105.22, -142.41, 84125.63, 19486.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76ac64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.59,38.6a2.32,2.32,0,0,0-.92.29l-19,11,20.48,37.3a2.28,2.28,0,0,0,.82-.28l19-11a2.31,2.31,0,0,0,1.11-1.57L74.25,38.63a2.39,2.39,0,0,0-.47,0H73.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -315.32,
    y1: 370.48,
    x2: -315.01,
    y2: 370.48,
    gradientTransform: "matrix(129.89, 0, 0, -129.89, 41010.86, 48184.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79b461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75ac64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3e863d"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "node-js-logo-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.85,133.09a3.8,3.8,0,0,1-1.89-.51l-6-3.57c-.9-.5-.46-.68-.16-.78A12.17,12.17,0,0,0,93.49,127a.46.46,0,0,1,.45,0l4.63,2.75a.61.61,0,0,0,.56,0l18.06-10.43a.57.57,0,0,0,.28-.49V98a.58.58,0,0,0-.28-.5L99.14,87.09a.56.56,0,0,0-.56,0L80.53,97.51a.58.58,0,0,0-.29.49v20.84a.56.56,0,0,0,.28.48l4.95,2.86c2.69,1.34,4.33-.24,4.33-1.83V99.78a.52.52,0,0,1,.52-.52h2.29a.52.52,0,0,1,.52.52v20.58c0,3.58-2,5.64-5.35,5.64a7.74,7.74,0,0,1-4.16-1.13l-4.74-2.73a3.82,3.82,0,0,1-1.89-3.3V98a3.8,3.8,0,0,1,1.89-3.29L97,84.28a4,4,0,0,1,3.8,0l18.06,10.43A3.81,3.81,0,0,1,120.71,98v20.84a3.82,3.82,0,0,1-1.89,3.29l-18.06,10.43a3.8,3.8,0,0,1-1.9.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.43,118.72c-7.9,0-9.56-3.63-9.56-6.67a.52.52,0,0,1,.52-.52h2.33a.52.52,0,0,1,.52.44c.35,2.38,1.4,3.58,6.18,3.58,3.81,0,5.43-.86,5.43-2.88,0-1.16-.46-2-6.37-2.6-4.95-.49-8-1.58-8-5.53,0-3.64,3.07-5.81,8.22-5.81,5.78,0,8.65,2,9,6.32a.53.53,0,0,1-.14.4.54.54,0,0,1-.38.17h-2.35a.52.52,0,0,1-.51-.41c-.57-2.5-1.93-3.3-5.64-3.3-4.15,0-4.64,1.45-4.64,2.53,0,1.32.57,1.7,6.18,2.44s8.19,1.78,8.19,5.68-3.28,6.19-9,6.19m22-22.1H127a.53.53,0,0,0,.59-.55c0-.53-.37-.53-.57-.53h-.62Zm-.74-1.71H127c.46,0,1.37,0,1.37,1a.9.9,0,0,1-.74,1c.54,0,.57.39.65.89a3.81,3.81,0,0,0,.2,1h-.83c0-.18-.15-1.18-.15-1.23-.05-.22-.13-.33-.41-.33h-.68v1.56h-.76Zm-1.61,1.94A2.92,2.92,0,1,0,127,94a2.92,2.92,0,0,0-2.91,2.91m6.4,0A3.48,3.48,0,1,1,127,93.4a3.49,3.49,0,0,1,3.48,3.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.92,51.53a2.31,2.31,0,0,0-1.16-2l-19.15-11a2.24,2.24,0,0,0-1.05-.3h-.2a2.28,2.28,0,0,0-1.06.3l-19.15,11a2.33,2.33,0,0,0-1.16,2L0,81.21a1.14,1.14,0,0,0,.57,1,1.09,1.09,0,0,0,1.15,0l11.38-6.52a2.33,2.33,0,0,0,1.16-2V59.82a2.31,2.31,0,0,1,1.16-2L20.31,55a2.3,2.3,0,0,1,1.16-.31,2.26,2.26,0,0,1,1.15.31l4.84,2.79a2.31,2.31,0,0,1,1.16,2V73.68a2.34,2.34,0,0,0,1.16,2L41.15,82.2a1.13,1.13,0,0,0,1.16,0,1.16,1.16,0,0,0,.57-1ZM133.28,67a.57.57,0,0,1-.29.5l-6.58,3.79a.58.58,0,0,1-.58,0l-6.58-3.79A.57.57,0,0,1,119,67V59.39a.58.58,0,0,1,.28-.5l6.57-3.8a.58.58,0,0,1,.58,0l6.58,3.8a.58.58,0,0,1,.29.5Zm1.78-56.24a1.16,1.16,0,0,0-1.72,1V41.14a.81.81,0,0,1-1.21.7l-4.8-2.76a2.31,2.31,0,0,0-2.31,0L105.86,50.13a2.31,2.31,0,0,0-1.16,2V74.25a2.32,2.32,0,0,0,1.16,2L125,87.31a2.32,2.32,0,0,0,2.31,0l19.16-11.07a2.32,2.32,0,0,0,1.16-2V19.12a2.32,2.32,0,0,0-1.19-2Zm63.79,48.45a2.31,2.31,0,0,0,1.15-2V51.83a2.31,2.31,0,0,0-1.15-2l-19-11a2.31,2.31,0,0,0-2.32,0L158.34,49.84a2.31,2.31,0,0,0-1.16,2V73.95a2.32,2.32,0,0,0,1.17,2l19,10.85a2.31,2.31,0,0,0,2.27,0l11.51-6.4a1.15,1.15,0,0,0,0-2L171.9,67.35a1.15,1.15,0,0,1-.58-1V59.42a1.15,1.15,0,0,1,.58-1l6-3.46A1.14,1.14,0,0,1,179,55l6,3.46a1.15,1.15,0,0,1,.58,1v5.45a1.15,1.15,0,0,0,1.74,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.37,58.16a.44.44,0,0,1,.44,0l3.68,2.12a.44.44,0,0,1,.22.38v4.25a.44.44,0,0,1-.22.38l-3.68,2.12a.44.44,0,0,1-.44,0l-3.67-2.12a.44.44,0,0,1-.23-.38V60.66a.44.44,0,0,1,.22-.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.41,48,60.74,21.71,33.22,77.85l53.67,26.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29.73,55.8l37.9,51.29,50.12-37L79.85,18.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M53.67,38.59V87.16H95.12V38.59Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 143.68
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW4);
export default __webpack_public_path__ + "static/media/w4.b94b977c7757104d681b3600063e6ebd.svg";
export { ForwardRef as ReactComponent };